// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavB_wrapper__1krOX","header":"NavB_header__2JFAS"};